import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';
import billServices from '../../../../../services/admFin/billServices';

export default function FilterBillsPopUp(props) {
    const [companies, setCompanies] = useState([]);
    const [collaborators, setCollaborators] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    //const [status, setStatus] = useState([]);

    const [filterFields, setFilterFields] = useState({
        empresa: "",
        colaborador: "",
        forma_de_pagamento: "",
        data_venc: "",
        data_venc_min: "",
        status: "Não Pagas",
    });

    async function readInfoNewBill() {
        const response = await billServices.getInfoNewBill();
        if (response.status === 200) {
            setCompanies(response.data.empresas);
            setPaymentMethods(response.data.formas_de_pagamento);
            setCollaborators(response.data.colaboradores);
        } else
            alert("Erro ao ler informações auxiliares 3, tente novamente!");
    }
    

    useEffect(() => {
        readInfoNewBill();
    }, []);

    useEffect(() => {
        if(props.bills.length > 0)
            onFilter();
    }, [props.bills]);


    function onFilter() {
        let auxArray = [...props.bills];
        if(filterFields.empresa !== "") {
            auxArray = auxArray.filter(obj => obj.empresa && obj.empresa.id === companies.find(company => filterFields.empresa === company.nome).id);
        }

        if(filterFields.colaborador !== "") {
            auxArray = auxArray.filter(obj => obj.colaborador && obj.colaborador.id === collaborators.find(collaborator => filterFields.colaborador === collaborator.nome).id);
        }

        if(filterFields.forma_de_pagamento !== "") {
            auxArray = auxArray.filter(obj => obj.forma_de_pagamento && obj.forma_de_pagamento.id === paymentMethods.find(paymentMethod => filterFields.forma_de_pagamento === paymentMethod.nome).id);
        }

        if(filterFields.data_venc !== "") {
            auxArray = auxArray.filter(obj => obj.data_venc <= filterFields.data_venc);
        }

        if(filterFields.data_venc_min !== "") {
            auxArray = auxArray.filter(obj => obj.data_venc >= filterFields.data_venc_min);
        }

        if(filterFields.status === "Não Pagas") {
            auxArray = auxArray.filter(obj => obj.paga === false);
        }

        else if(filterFields.status === "Pagas") {
            auxArray = auxArray.filter(obj => obj.paga === true);
        }

        else{
            auxArray = auxArray.filter(obj => obj.paga === false || true);
        }

        props.setBills(auxArray);
    }

    function onResetFilters() {
        setFilterFields({
            empresa: "",
            colaborador: "",
            forma_de_pagamento: "",
            data_venc: "",
            data_venc_min: "",
            status: "Não Pagas",
        });
    }

    function isReseted() {
        for(const key of Object.keys(filterFields)) {
            if (key === "status" && filterFields[key] !== "Não Pagas"){
                return false;                
            }
            else if(key !== "status" && filterFields[key])
                return false;
        }
        return true;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='bills-filter-container'>
                <Input
                label="Empresa"
                type="select"
                id="bills-filter-company"
                options={companies.map(company => company.nome)}
                onChange={(e) => setFilterFields({...filterFields, empresa: e.target.value})}
                cleanValue=""
                value={filterFields.empresa}
                />

                <Input
                    label="Colaborador"
                    type="select"
                    id="bills-filter-collaborator"
                    options={collaborators.map(collaborator => collaborator.nome)}
                    onChange={(e) => setFilterFields({...filterFields, colaborador: e.target.value})}
                    cleanValue=""
                    value={filterFields.colaborador}
                />

                <div className='bills-filter-inner-container'>
                    <Input
                    label="Vencimento min."
                    type="date"
                    id="bills-filter-min-due-date"
                    onChange={(e) => setFilterFields({...filterFields, data_venc_min: e.target.value})}
                    cleanValue=""
                    value={filterFields.data_venc_min}
                    />
                    <Input
                    label="Vencimento máx."
                    type="date"
                    id="bills-filter-due-date"
                    onChange={(e) => setFilterFields({...filterFields, data_venc: e.target.value})}
                    cleanValue=""
                    value={filterFields.data_venc}
                    />
                </div>
                <Input
                label="Forma de Pag."
                type="select"
                id="bills-filter-payment-method"
                options={paymentMethods.map(paymentMethod => paymentMethod.nome)}
                onChange={(e) => setFilterFields({...filterFields, forma_de_pagamento: e.target.value})}
                cleanValue=""
                value={filterFields.forma_de_pagamento}
                />


                <Input
                    label="Status"
                    type="select"
                    noFilterOptions
                    id="bills-filter-status"
                    options={["Todos", "Pagas", "Não Pagas"]}
                    onChange={(e) => setFilterFields({...filterFields, status: e.target.value})}
                    value={filterFields.status}
                />
            </div>
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}